import React from 'react';

const Footer = () => (
  <footer className="footer">
    <p>© {new Date().getFullYear()} AiLogify. All rights reserved.</p>
  </footer>
);

export default Footer;